export default __webpack_public_path__ + "static/media/LightBlue0003.0677acf8.png";